import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  validatedate_min_max,
  getlocalstoragedate,
  setlocalstoragedate,
  csvFileName,
} from "../SystemUtility/SystemUtility";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import ProductionEntry2 from "./ProductionEntry2";
import CtCmbEditable from "./CustomTool/CtCmbEditable";

class ProductionList2 extends Component {
  state = {
    dataLoadStatus: true,
    columnsdata: [
      {
        accessorKey: "dat_date",
        header: "Date",
      },
      {
        accessorKey: "vac_title",
        header: "Title",
      },
      {
        accessorKey: "vac_fg",
        header: "FG Item",
      },
      {
        accessorKey: "vac_qty",
        header: "FG Qty",
      },
    ],
    Title: [
      {
        vac_title: "All",
      },
      {
        vac_title: "MC Lump",
      },
      {
        vac_title: "Light MC",
      },
    ],
    rows: [
      // {
      //   dat_date: "11-09-2024",
      //   vac_title: "abc",
      //   vac_fg: "abc",
      //   vac_qty: "abc",
      // },
    ],
    formData: {
      cmbTitle: "",
      dtpFromDate: get_YMD_from_SYS(get_30DaysBack_FromCurrentDate(new Date())),
      dtpToDate: get_YMD_from_SYS(new Date()),
    },
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Production List";
    this.props.setActiveMenu("ProductionList");
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleARDonActionClick_Edit = () => {};
  handleARDonActionClick_Delete = () => {};
  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<ProductionEntry2 />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          fullscreenOnly={true}
        />
      );
      this.setState({ ARD });
    });
    localStorage.setItem("Heading", "Production Entry");
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  //endregion function
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Production List</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbTitle"
                  label="Title"
                  items={this.state.Title}
                  value={this.state.formData.cmbTitle}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  colID="vac_title"
                />
              </Grid>

              <Grid item>
                <CtBtn label="Load" onClick={this.getInfo} />
              </Grid>
            </Grid>
            <Grid item marginTop={3} className="maintable">
              <MaterialTable
                rowsdata={this.state.rows}
                columnsdata={this.state.columnsdata}
                rowsPerPage={this.state.rowsPerPage}
                tblmaxHeight={500}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                tableButtonAction={[
                  {
                    label: "New Production ENtry",
                    onClick: this.handleOnNewEntryClick,
                    addPluseIcon: true,
                  },
                ]}
                rowIconAction={[
                  { label: "Edit", onClick: this.handleARDonActionClick_Edit },
                  {
                    label: "Delete",
                    onClick: this.handleARDonActionClick_Delete,
                  },
                ]}
                csvFileName={csvFileName("Production List")}
                density={"compact"}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ProductionList2))));
